(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["christmas-santa"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('tdc-santa-entrance')) {
    customElements.define('tdc-santa-entrance', class extends HTMLElement {
      connectedCallback() {
        if (this.started) return;
        this.started = true;
        this.timers = [];
        this.animations = [];
        const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        const giftEnabled = this.dataset.gift === 'true';
        const sleighEnabled = this.dataset.sleigh !== 'false';
        const visitKey = 'tdc-christmas-gift-2026-v1';
        const vehicle = this.querySelector('.tdc-santa__vehicle');
        const offer = this.querySelector('.tdc-santa__offer');
        const present = this.querySelector('.tdc-santa__present');
        const close = () => { if (offer) offer.hidden = true; };
        this.querySelector('[data-gift-close]')?.addEventListener('click', close);
        this.querySelector('[data-gift-shop]')?.addEventListener('click', () => {
          close();
          const products = document.querySelector('main .product-list, main [id*="product_list"]');
          if (products) products.scrollIntoView({behavior: motion.matches ? 'instant' : 'smooth', block: 'start'});
        });
        this.onEscape = e => { if (e.key === 'Escape' && offer && !offer.hidden) close(); };
        document.addEventListener('keydown', this.onEscape);
        const reveal = () => {
          if (!this.isConnected) return;
          document.documentElement.classList.remove('tdc-gift-arriving');
          if (!giftEnabled) return;
          document.documentElement.classList.add('tdc-gift-sale-ready');
          if (present) present.hidden = true;
          if (offer) {
            offer.hidden = false;
            if (!motion.matches) this.animations.push(offer.animate([
              {opacity:0,transform:'translate(-50%,-45%) scale(.92)'},
              {opacity:1,transform:'translate(-50%,-50%) scale(1)'}
            ], {duration:650,easing:'cubic-bezier(.2,.8,.2,1)',fill:'both'}));
          }
          const announcement = this.querySelector('[data-gift-announcement]');
          if (announcement) announcement.textContent = announcement.dataset.message;
          try { sessionStorage.setItem(visitKey, 'seen'); } catch {}
          if (!motion.matches) {
            const particles = this.querySelector('.tdc-santa__sparkles');
            for (let i=0; i<18; i++) {
              const p=document.createElement('span');
              p.textContent=i%3 ? '✧' : '✦';
              particles.appendChild(p);
              const angle=i/18*Math.PI*2, distance=90+(i%4)*32;
              const animation=p.animate([
                {opacity:0,transform:'translate(0,0) scale(.2)'},
                {opacity:1,offset:.2},
                {opacity:0,transform:'translate('+Math.cos(angle)*distance+'px,'+Math.sin(angle)*distance+'px) scale(1.1)'}
              ], {duration:1200,delay:(i%4)*50,fill:'both'});
              animation.onfinish=()=>p.remove();
              this.animations.push(animation);
            }
          }
        };
        let seen=false;
        try { seen=Boolean(sessionStorage.getItem(visitKey)); } catch {}
        if (seen) {
          document.documentElement.classList.remove('tdc-gift-arriving');
          this.remove();
          return;
        }
        const fly = () => {
          if (!this.isConnected) return;
          this.hidden = false;
          if (motion.matches || !sleighEnabled) {
            if (vehicle) vehicle.hidden=true;
            reveal();
            return;
          }
          if (giftEnabled) document.documentElement.classList.add('tdc-gift-arriving');
          const width=vehicle.getBoundingClientRect().width;
          const flight=vehicle.animate([
            {transform:'translate('+(-width-20)+'px,24px) rotate(-3deg)'},
            {transform:'translate('+(window.innerWidth+20)+'px,-44px) rotate(-3deg)'}
          ], {duration:6400,delay:900,easing:'linear',fill:'both'});
          this.animations.push(flight);
          flight.onfinish=()=>{vehicle.hidden=true;if(!giftEnabled)this.remove();};
          if (giftEnabled) {
            this.timers.push(setTimeout(()=>{
              if (!this.isConnected || !present || motion.matches) return;
              present.hidden=false;
              this.animations.push(present.animate([
                {transform:'translateY(-65px) rotate(-12deg) scale(.5)',opacity:0},
                {transform:'translateY(0) rotate(0) scale(1)',opacity:1}
              ], {duration:650,easing:'cubic-bezier(.2,.8,.2,1)',fill:'both'}));
            },3150));
            this.timers.push(setTimeout(reveal,4000));
          } else {
            try { sessionStorage.setItem(visitKey,'seen'); } catch {}
          }
        };
        this.onMotion = () => { if (motion.matches) reveal(); };
        motion.addEventListener('change', this.onMotion);
        this.motion=motion;
        if (document.visibilityState==='visible') fly();
        else {
          this.onVisible=()=>{
            if (document.visibilityState!=='visible') return;
            document.removeEventListener('visibilitychange',this.onVisible);
            fly();
          };
          document.addEventListener('visibilitychange',this.onVisible);
        }
      }
      disconnectedCallback() {
        this.timers?.forEach(clearTimeout);
        this.animations?.forEach(a=>a.cancel());
        if(this.onEscape)document.removeEventListener('keydown',this.onEscape);
        if(this.onVisible)document.removeEventListener('visibilitychange',this.onVisible);
        if(this.onMotion)this.motion.removeEventListener('change',this.onMotion);
        document.documentElement.classList.remove('tdc-gift-arriving');
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
